import React from "react";
import { Box, Container } from "@mui/system";
import { Button, Skeleton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";

export default function InternalBanner({
  banner,
  featuredImage,
  isAboutPage = false,
  isPosts = false,
  isSingleExperience = false,
}) {
  return (
    <Box
      sx={{
        backgroundImage: `url(${featuredImage})`,
        backgroundSize: "cover",
        backgroundPosition: isAboutPage ? "75%" : "center",
        backgroundRepeat: "no-repeat",
        height: "50vh",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
          mixBlendMode: "multiply",
        }}
      />
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
              md: "50%",
            },
          }}
        >
          {isSingleExperience ? (
            <Link to="/experience/">
              <Button
                sx={{
                  color: "#fff",
                  border: "2px solid #fff",
                  p: "0.5rem 1rem",
                  borderRadius: "2rem",
                  mb: "2rem",
                  cursor: "pointer",
                  fontSize: "0.875rem",
                  position: "relative",
                  transition: "all 0.2s ease-in-out",
                  overflow: "hidden",
                  fontWeight: "800",
                  fontSize: "0.875rem",
                  "&::after": {
                    content: "''",
                    position: "absolute",
                    zIndex: "-1",
                    transition: "all 0.2s ease-in-out",
                    width: "100%",
                    height: "0%",
                    top: "0",
                    left: "0",
                    backgroundColor: "rgba(255,114,28,0.7)",
                  },
                  "&:hover": {
                    "&::after": {
                      height: "100%",
                    },
                  },
                }}
              >
                <KeyboardDoubleArrowLeftIcon
                  sx={{
                    mr: "0.25rem",
                    fontSize: "1rem",
                  }}
                />
                More Experiences
              </Button>
            </Link>
          ) : null}
          <Typography
            variant="h1"
            sx={{
              fontSize: "3rem",
              fontWeight: 600,
              mb: "1rem",
            }}
          >
            {banner ? (
              banner.banner_title
            ) : (
              <Skeleton
                sx={{
                  maxWidth: "300px",
                }}
              />
            )}
          </Typography>
          <Typography
            variant="p"
            component="p"
            sx={{
              fontSize: "1.2rem",
              fontWeight: 500,
            }}
          >
            {banner ? (
              banner.banner_text
            ) : (
              <Skeleton variant="rectangular" height={100} />
            )}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
